import { IconProps } from '@models/icons';

function ToastFail({ size = 24, color = '#E81212', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="12.5" cy="12" r="6" fill={color}/>
            <path d="M15 9.5L10 14.5" stroke="white" strokeLinecap="round"/>
            <path d="M10 9.5L15 14.5" stroke="white" strokeLinecap="round"/>
        </svg>
  );
}

export default ToastFail;
